import {
  Box,
  DialogContent,
  Stack,
  DialogActions,
  Skeleton,
} from '@mui/material';

export function ProductFormPlaceholder() {
  return (
    <Box>
      <DialogContent dividers sx={{ py: 3, px: 2 }}>
        <Stack>
          <Skeleton height={72} />
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
            <Skeleton width="100%" height={72} />
            <Skeleton width="100%" height={72} />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
            <Skeleton width="100%" height={72} />
            <Skeleton width="100%" height={72} />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Skeleton width={100} height={56} />
        <Skeleton width={100} height={56} />
      </DialogActions>
    </Box>
  );
}
